/*
 * Script usado cuando un webview de app va a parar a una pagina que necesita login. 
 */

import { logger } from '../infrastructure/datadog/datadog';

window.setTimeout(
  () => {
    if(typeof Trendier === "object") { 
      Trendier.login(); 
      logger.warn("force login app");
    } else {
      /*
       * Si no existe el objeto Trendier, es que hemos acabado en una vista de app desde una redireccion de navegador, por ejemplo poque hemos completado un pago con paypal.
       * Redirect_to tiene un deeplink para volver a la app
       **/
      const url = new URL(window.location.href),
        redirectTo = url.searchParams.get('redirect_to');
      if(redirectTo){
        logger.info("force reopen app");
        window.location.href = redirectTo;
      }
    }
    
    //Si no se ha conseguido lanzar la pantalla de login, llorar
    window.setTimeout(() => document.getElementById('app-auth-error').classList.remove('d-none'), 4000);
  },
  10
);
